import React from 'react';
import '@styled-system/css';
import merge from 'deepmerge';
import { clsx } from 'clsx';
import classes from './SkeletonBox.module.css.js';
import { defaultSxProp } from '../../utils/defaultSxProp.js';
import Box from '../../Box/Box.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SkeletonBox = /*#__PURE__*/React.forwardRef(function SkeletonBox({
  height,
  width,
  className,
  style,
  sx: sxProp = defaultSxProp,
  ...props
}, ref) {
  if (sxProp !== defaultSxProp) {
    return /*#__PURE__*/React.createElement(Box, _extends({
      as: "div",
      className: clsx(className, classes.SkeletonBox),
      style: merge(style, {
        height,
        width
      })
    }, props, {
      ref: ref,
      sx: sxProp
    }));
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx(className, classes.SkeletonBox),
    style: merge(style, {
      height,
      width
    })
  }, props, {
    ref: ref
  }));
});

export { SkeletonBox };
